
import '../vendor/jquery.cookie-1.4.1';
import '../vendor/jquery.scrollbar-0.2.10';
import './modules/jsClick';
import './modules/popupFunctions';
import { initCookieHandlers } from "./modules/cookies/handlers";

export function onDocumentReady() {
    $.urlParam = function(name: string) {
        const results = new RegExp(`[\?&]${name}=([^&#]*)`, 'i').exec(window.location.href);

        if (results == null) {
            return false;
        } else {
            return results[1] || false;
        }
    };

    $('.ornament_popup .scrollbar-rail').scrollbar();

    initCookieHandlers();
}

$(onDocumentReady);
